import _ from 'lodash-es';
import angular from 'angular';
import { createNumberMask } from 'text-mask-addons';
import kformUtils from '../../utils/kform-utils';
import template from './number.html';

const isNumeric = (/** @type {any} */ n) => !Number.isNaN(Number.parseFloat(n)) && Number.isFinite(n);

const numberConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('number', {
		title:      'Number',
		template,
		/**
		 * @param {any} data
		 * @param {any} options
		 * @returns {any}
		 */
		tableView(data, options) {
			if (_.isNil(data)) {
				return '';
			}

			const { getNumberDecimalLimit, formatNumber, getNumberSeparators } = options.util;
			const separators = getNumberSeparators();
			const { component } = options;
			const decimalLimit = getNumberDecimalLimit(component);

			if (!component.delimiter) {
				separators.delimiter = '';
			}

			return formatNumber(data, createNumberMask({
				prefix:                   '',
				suffix:                   '',
				delimiter:                _.get(component, 'thousandsSeparator', separators.delimiter),
				decimalSymbol:            _.get(component, 'decimalSymbol', separators.decimalSeparator),
				decimalLimit:             _.get(component, 'decimalLimit', decimalLimit),
				allowNegative:            _.get(component, 'allowNegative', true),
				allowDecimal:             _.get(component, 'allowDecimal', !(component.validate && component.validate.integer)),
			}));
		},
		children:   false,
		selectable: true,
		settings:   {
			autofocus:      false,
			disabled:       false,
			input:          true,
			tableView:      true,
			inputType:      'number',
			label:          'Number',
			key:            'number',
			hideLabel:      false,
			placeholder:    '',
			prefix:         '',
			suffix:         '',
			defaultValue:   '',
			protected:      false,
			persistent:     true,
			hidden:         false,
			clearOnHide:    true,
			validate:       {
				card:     '0-1',
				min:      '',
				max:      '',
				step:     'any',
				integer:  '',
				custom:   '',
			},
			decimalLimit:   0,
			delimiter:      false,
			requireDecimal: false,
			event:          {
				onChange: null,
			},
			kdata:          {
				submit: true,
			},
		},
		icon:          'fa fa-hashtag',
		views:         [
			{
				name:     'Display',
				template: 'kform/components/number/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/number/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/number/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.maskOptions = {
				padFractionalZeros: $scope.component.requireDecimal,
				scale:              $scope.component.decimalLimit,
			};

			if ($scope.options?.building) {
				return;
			} // FOR-71 - Skip parsing input data.

			// Ensure that values are numbers.
			if ($scope.data && Object.prototype.hasOwnProperty.call($scope.data, $scope.component.key)) {
				if (Array.isArray($scope.data[$scope.component.key])) {
					for (const [index, value] of $scope.data[$scope.component.key].entries()) {
						if (!isNumeric(value)) {
							$scope.data[$scope.component.key][index] = Number.parseFloat(value);
						}
					}
				}
				else if ($scope.data[$scope.component.key] !== undefined && !isNumeric($scope.data[$scope.component.key])) {
					$scope.data[$scope.component.key] = Number.parseFloat($scope.data[$scope.component.key]);
				}
			}

			$scope.changeValue = () => {
				if (typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};

			$scope.isRequired = (
				/** @type {any} */ component,
				/** @type {any[]} */ componentsToRequire,
			) => (component.validate && component.validate.card.isRequired())
				|| (Array.isArray(componentsToRequire) && componentsToRequire.includes(component.key));
		},
	});
};

export default angular.module('app').config(numberConfig);
